import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useGetDashboardQuery } from '../../api/dashboardApiSlice';
import { DateRangeFilterButton } from '../../components/DateRangeFilterButton';
import FilterButton, { FilterGroup }  from '../../components/FilterButton';
import Kpis from '../../components/metrics/Kpis';
import Tabs from '../../components/Tabs';
import Title from '../../components/Title';
import get from 'lodash/get';
import AdminDashboardDeviceTab from '../../components/admin_dashboard/tabs/AdminDashboardDeviceTab';
import AdminDashboardConsentTab from '../../components/admin_dashboard/tabs/AdminDashboardConsentTab';
import AdminDashboardVersionTab from '../../components/admin_dashboard/tabs/AdminDashboardVersionTab';
import AdminDashboardAppTab from '../../components/admin_dashboard/tabs/AdminDashboardAppTab';
import LazyLoad from '../../components/LazyLoad';

const AdminDashboard = () => {
	const { t } = useTranslation();
  const [filter, setFilter] = useState({})
  const { data: kpis = {}, isSuccess } = useGetDashboardQuery({filter})
  const sdk_versions = useMemo(() => (get(kpis, 'sdk_versions', [])), [get(kpis, 'sdk_versions', []).length])
  const kpiLoadedOnce = useMemo(() => !!kpis.devices, [JSON.stringify(kpis)])

  return (<>
    <Title main={"Dashboard"}></Title>
    <FilterGroup onChange={setFilter}>
      <DateRangeFilterButton
        startDate={kpis.start_date}
        endDate={kpis.end_date}/>
      <FilterButton
        title={"OS"}
        options={useMemo(() => (["ios", "android"].map(os => ({label: t(os), value: os}))), [])}
        search={false}
        includeAll={true}
        selected={get(filter, 'os')}
        name="os"/>
      <FilterButton
        title={t("app.sdk_version")}
        options={sdk_versions}
        search={true}
        selected={get(filter, 'sdk_version')}
        includeAll={true}
        name="sdk_version"/>
    </FilterGroup>
    <Kpis data={kpis} isSuccess={isSuccess}/>
    { kpiLoadedOnce && <>
      <Tabs active={"devices"}>
        <LazyLoad as="devices" icon="mobile">
          <AdminDashboardDeviceTab filter={filter}/>
        </LazyLoad>
        <LazyLoad as="consent" icon="consent">
          <AdminDashboardConsentTab filter={filter} as="consent" icon="consent"/>
        </LazyLoad>
        <LazyLoad as="version" icon="branch">
          <AdminDashboardVersionTab filter={filter} setFilter={setFilter} as="version" icon="branch"/>
        </LazyLoad>
        <LazyLoad as="app" icon="app">
          <AdminDashboardAppTab filter={filter} as="app" icon="app"/>
        </LazyLoad>
      </Tabs>
    </>}
  </>);
}

export default AdminDashboard;